import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Card';
import Spiral from '../components/Spiral';
import ThemeToggle from '../components/ThemeToggle';
import { useTheme } from '../hooks/useTheme';
import { fetchWordsCount } from '../utils/api';
import grammarIconLight from '../assets/light/grammar.svg';
import travelIconLight from '../assets/light/travel.svg';
import dictionaryIconLight from '../assets/light/dictionary.svg';
import aiIconLight from '../assets/light/aiIcon.svg';
import grammarIconDark from '../assets/dark/grammar.svg';
import travelIconDark from '../assets/dark/travel.svg';
import dictionaryIconDark from '../assets/dark/dictionary.svg';
import aiIconDark from '../assets/dark/aiIcon.svg';
import logger from '../utils/logger';
const pluralizeWord = (count: number): string => {
  if (count === 0) return 'слов';
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'слов';
  }
  if (lastDigit === 1) {
    return 'слово';
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'слова';
  }
  return 'слов';
};
const Home = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [learnedCount, setLearnedCount] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const loadLearnedWordsCount = async () => {
      try {
        setIsLoading(true);
        const response = await fetchWordsCount('LEARNED');
        if (response.success && response.data !== undefined) {
          logger.log('Получено количество изученных слов:', response.data);
          setLearnedCount(response.data);
        } else {
          logger.error('Ошибка при загрузке количества слов:', response.error);
          setLearnedCount(0);
        }
      } catch (error) {
        logger.error('Исключение при загрузке количества слов:', error);
        setLearnedCount(0);
      } finally {
        setIsLoading(false);
      }
    };
    loadLearnedWordsCount();
  }, []);
  const handleCardClick = (path: string) => {
    navigate(path);
  };
  const cards = [
    {
      label: "Комбинации",
      className: "tall",
      path: '/combinations',
      content: <Spiral />
    },
    {
      label: "Грамматика",
      path: '/grammar',
      icon: theme === 'light' ? grammarIconLight : grammarIconDark
    },
    {
      label: "В дороге",
      path: '/travel',
      icon: theme === 'light' ? travelIconLight : travelIconDark
    },
    {
      label: "Словарь",
      path: '/dictionary',
      icon: theme === 'light' ? dictionaryIconLight : dictionaryIconDark
    },
    {
      label: "ИИ",
      path: '/ai',
      icon: theme === 'light' ? aiIconLight : aiIconDark
    }
  ];
  return (
    <div className="container">
      <div className="small">
        {(
          <>
            {learnedCount !== null ? `${learnedCount} ${pluralizeWord(learnedCount)}` : '0 слов'}<br/>
            <span>но это пока</span>
          </>
        )}
      </div>
      <div className="theme-toggle">
        <ThemeToggle />
      </div>
      {cards.map((card) => (
        <Card 
          key={card.label}
          label={card.label}
          className={card.className}
          icon={card.icon}
          onClick={() => handleCardClick(card.path)}
        >
          {card.content}
        </Card>
      ))}
    </div>
  );
};
export default Home; 